import React, { useContext } from "react";

import {
  GlobalContext,
  OpinionConsumer,
  OpinionProvider,
  OpinionProviderState,
} from "@/contexts";
import { Opinion, OpinionResult } from "@/service/Model";

import MeterAssembler from "./MeterAssembler";
import * as MeterConstants from "./MeterConstants";
import { MeterWrapper } from "./styles";

type MeterProps = {
  interaction: Opinion;
  interactionResults: OpinionResult;
};

const MeterContainer: React.FC<MeterProps> = (
  props: MeterProps
): JSX.Element => {
  const { interaction, interactionResults } = props;
  const globalContext = useContext(GlobalContext);

  const renderMeterAssembler = (
    opinionContext: OpinionProviderState
  ): JSX.Element => {
    const opinionValue = opinionContext.opinionValue;
    const votedAnswer = opinionValue ? opinionValue.answer : undefined;
    return (
      <MeterAssembler
        interaction={interaction}
        interactionResults={interactionResults}
        previousAnswer={votedAnswer}
        icons={globalContext.icons}
        onRegistation={globalContext.handleRegistration}
        tealiumConfig={globalContext.tealiumConfig}
        onAnswer={(answer: number) => {
          if (opinionContext && opinionContext.onMeterAnswer) {
            opinionContext.onMeterAnswer(interaction.id, interactionResults, {
              answer: answer,
              minAnswer: MeterConstants.minAnswer,
              maxAnswer: MeterConstants.maxAnswer,
              bucketsCount: MeterConstants.bucketsCount,
            });
          }
        }}
      />
    );
  };

  return (
    <MeterWrapper>
      <OpinionProvider
        interaction={interaction}
        interactionResults={interactionResults}
        preview={!!globalContext.query.preview}
      >
        <OpinionConsumer>
          {(opinionContext: OpinionProviderState) =>
            renderMeterAssembler(opinionContext)
          }
        </OpinionConsumer>
      </OpinionProvider>
    </MeterWrapper>
  );
};

export default MeterContainer;
